/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateJournalSupportRequest,
  JournalSupportResponse,
  ProblemDetails,
  UpdateJournalSupportRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateJournalSupportRequestFromJSON,
    CreateJournalSupportRequestToJSON,
    JournalSupportResponseFromJSON,
    JournalSupportResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateJournalSupportRequestFromJSON,
    UpdateJournalSupportRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateJournalSupportOperationRequest {
    createJournalSupportRequest: CreateJournalSupportRequest;
}

export interface EndJournalSupportRequest {
    id: string;
}

export interface UpdateJournalSupportOperationRequest {
    id: string;
    updateJournalSupportRequest: UpdateJournalSupportRequest;
}

/**
 * JournalSupportsApi - interface
 * 
 * @export
 * @interface JournalSupportsApiInterface
 */
export interface JournalSupportsApiInterface {
    /**
     * 
     * @param {CreateJournalSupportRequest} createJournalSupportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalSupportsApiInterface
     */
    createJournalSupportRaw(requestParameters: CreateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>>;

    /**
     */
    createJournalSupport(requestParameters: CreateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalSupportsApiInterface
     */
    endJournalSupportRaw(requestParameters: EndJournalSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>>;

    /**
     */
    endJournalSupport(requestParameters: EndJournalSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalSupportsApiInterface
     */
    getActiveJournalSupportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JournalSupportResponse>>>;

    /**
     */
    getActiveJournalSupports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JournalSupportResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateJournalSupportRequest} updateJournalSupportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalSupportsApiInterface
     */
    updateJournalSupportRaw(requestParameters: UpdateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>>;

    /**
     */
    updateJournalSupport(requestParameters: UpdateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse>;

}

/**
 * 
 */
export class JournalSupportsApi extends runtime.BaseAPI implements JournalSupportsApiInterface {

    /**
     */
    async createJournalSupportRaw(requestParameters: CreateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>> {
        if (requestParameters['createJournalSupportRequest'] == null) {
            throw new runtime.RequiredError(
                'createJournalSupportRequest',
                'Required parameter "createJournalSupportRequest" was null or undefined when calling createJournalSupport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/journal-supports`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateJournalSupportRequestToJSON(requestParameters['createJournalSupportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JournalSupportResponseFromJSON(jsonValue));
    }

    /**
     */
    async createJournalSupport(requestParameters: CreateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse> {
        const response = await this.createJournalSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async endJournalSupportRaw(requestParameters: EndJournalSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling endJournalSupport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/journal-supports/{id}/end`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JournalSupportResponseFromJSON(jsonValue));
    }

    /**
     */
    async endJournalSupport(requestParameters: EndJournalSupportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse> {
        const response = await this.endJournalSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getActiveJournalSupportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JournalSupportResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/journal-supports/active`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JournalSupportResponseFromJSON));
    }

    /**
     */
    async getActiveJournalSupports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JournalSupportResponse>> {
        const response = await this.getActiveJournalSupportsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateJournalSupportRaw(requestParameters: UpdateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JournalSupportResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateJournalSupport().'
            );
        }

        if (requestParameters['updateJournalSupportRequest'] == null) {
            throw new runtime.RequiredError(
                'updateJournalSupportRequest',
                'Required parameter "updateJournalSupportRequest" was null or undefined when calling updateJournalSupport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/journal-supports/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJournalSupportRequestToJSON(requestParameters['updateJournalSupportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JournalSupportResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateJournalSupport(requestParameters: UpdateJournalSupportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JournalSupportResponse> {
        const response = await this.updateJournalSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
